<div class="wrapper">

    <!-- Preloader -->
    <!-- <div class="preloader flex-column justify-content-center align-items-center">
      <img class="animation__shake" src="assets/dist/img/AdminLTELogo.png" alt="AdminLTELogo" height="60" width="60">
    </div> -->
  
    <!-- Navbar -->
    <nav class="main-header navbar navbar-expand navbar-white navbar-light">
      <!-- Left navbar links -->
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
        </li>
        <!-- <li class="nav-item d-none d-sm-inline-block">
          <a href="index3.html" class="nav-link">Home</a>
        </li>
        <li class="nav-item d-none d-sm-inline-block">
          <a href="#" class="nav-link">Contact</a>
        </li> -->
      </ul>
  
      <!-- Right navbar links -->
      <ul class="navbar-nav ml-auto">
        <!-- Navbar Search -->
        <!-- <li class="nav-item">
          <a class="nav-link" data-widget="navbar-search" href="#" role="button">
            <i class="fas fa-search"></i>
          </a>
          <div class="navbar-search-block">
            <form class="form-inline">
              <div class="input-group input-group-sm">
                <input class="form-control form-control-navbar" type="search" placeholder="Search" aria-label="Search">
                <div class="input-group-append">
                  <button class="btn btn-navbar" type="submit">
                    <i class="fas fa-search"></i>
                  </button>
                  <button class="btn btn-navbar" type="button" data-widget="navbar-search">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </li> -->
  
        
      </ul>
    </nav>
    <!-- /.navbar -->
  
    <!-- Main Sidebar Container -->
    <aside class="main-sidebar sidebar-dark-primary elevation-4" style="position: fixed;">
      <!-- Brand Logo -->
      <a  class="brand-link">
        <img src="assets/dmk.png" alt="AdminLTE Logo" class="img-circle elevation-2" style="opacity: .8;width:15%">
        <span class="brand-text font-weight-light">DMK Engineers Wing</span>
      </a>
  
      <!-- Sidebar -->
      <div class="sidebar">
        <!-- Sidebar user panel (optional) -->
        <div class="user-panel mt-3 d-flex">
          <div class="image">
            <img src="assets/user-icon.png" class="img-circle elevation-2" alt="User Image">
          </div>
          <div class="info">
            <a  class="d-block"> OFFICE BEARER</a>
          </div>
        </div>
  
        <!-- SidebarSearch Form -->
        <!-- <div class="form-inline">
          <div class="input-group" data-widget="sidebar-search">
            <input class="form-control form-control-sidebar" type="search" placeholder="Search" aria-label="Search">
            <div class="input-group-append">
              <button class="btn btn-sidebar">
                <i class="fas fa-search fa-fw"></i>
              </button>
            </div>
          </div>
        </div> -->
  
        <!-- Sidebar Menu -->
        <nav class="mt-2">
            <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false" style="height:100%;">
              <li class="nav-item">
                <a [routerLink]="['Dashboard']" class="nav-link">
                  <i class=""></i>
                  <p>
                    Dashboard
                  </p>
                </a>
              </li>
                <!-- <li class="nav-item">
                    <a  [routerLink]="['Dashboard']" class="nav-link">
                      <i class=""></i>
                        
                       </p>
                    </a>
                  </li> -->
                 
                  <li class="nav-item">
                    <a  [routerLink]="['appoint-district-office-bearers']" class="nav-link">
                      <i class=""></i>
                      <p>
                       Office Bearers  </p>
                    </a>
                  </li>
                  <!-- <li class="nav-item" >
                    <a  [routerLink]="['request-office-bearers-change']" class="nav-link">
                      <i class=""></i>
                      <p>
                        Request Office Bearer Change
  </p>
                    </a>
                  </li> -->
                  <li class="nav-item" >
                    <a  [routerLink]="['meetings']" class="nav-link">
                      <p>Meetings</p>
                    </a>
                  </li>
                  <!-- <li class="nav-item">
                    <a  [routerLink]="['districtwise-engieers-report']" class="nav-link">
                      <i class=""></i>
                      <p>
                        Report
                   </p>
                    </a>
                  </li>
                   -->
                   <li class="nav-item">
                    <a  [routerLink]="['menu-change-password']" class="nav-link">
                      <i class=""></i>
                      <p>
                        Change Password
                       </p>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a  [routerLink]="['profile']" class="nav-link">
                      <i class=""></i>
                      <p>
                        Profile
                       </p>
                    </a>
                  </li>                
                 
                 
                  <li class="nav-item">
                    <a class="nav-link" onMouseOver="this.style.cursor='pointer'">
                      <i class=""></i>
                      <p (click)="signout()">
                        Sign Out
                       </p>
                    </a>
                  </li>

            </ul>
          
        </nav>
        <!-- /.sidebar-menu -->
      </div>
      <!-- /.sidebar -->
    </aside>
  
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <!--  -->
      <!-- /.content-header -->
  
      <router-outlet></router-outlet>
    </div>
    <!-- /.content-wrapper -->
    <!-- <footer class="main-footer">
      <strong>Copyright &copy; 2014-2021 <a href="https://adminlte.io">AdminLTE.io</a>.</strong>
      All rights reserved.
      <div class="float-right d-none d-sm-inline-block">
        <b>Version</b> 3.2.0
      </div>
    </footer> -->
  
    <!-- Control Sidebar -->
    <aside class="control-sidebar control-sidebar-dark">
      <!-- Control sidebar content goes here -->
    </aside>
    <!-- /.control-sidebar -->
  </div>